import {APP_TOGGLE_SIDE_MENU} from "./types";

export const toggleSideMenu = () => (dispatch) => {
    dispatch({ type: APP_TOGGLE_SIDE_MENU });
}

